import { useTranslation } from "react-i18next"
import Button from "../Assets/Button/Button"

const OrdersLineError = () => {
  const { t } = useTranslation("translation", { keyPrefix: `interface` })

  return (
    <>
      <p style={{ marginBottom: "20px" }}>{t("ordersErrorDataFetch")}</p>
      <Button txt={t("refreshPage")} onClick={() => window.location.reload()} />
    </>
  )
}

export default OrdersLineError
